export const isMobile = () => {
    return window.innerWidth < 480;
  }

  export default isMobile;